// extracted by mini-css-extract-plugin
export var anchor = "_58-0";
export var discard = "_58-4";
export var muiTooltipTooltip = "_58-6";
export var notificationBar = "_58-3";
export var saveButtonHoverSlotWrapper = "_58-5";
export var show = "_58-2";
export var spacer = "_58-1";